import httpV2 from '@/utils/httpV2';

const state = {

};
const getters = {};

const mutations = {};

const actions = {

	getGoodsReservationPage({ state, commit }, params) {
	    let res = httpV2.post(`/b2c/v1.0/goods/reservation/page/search?page=${params.page}&limit=${params.limit}`, params, this);
	    return res;
	},
	 
	exportGoodsReservationExcel({ state, commit }, params) {
        let res = httpV2.postExportData("/b2c/v1.0/goods/reservation/export", params, this);
        return res;
    },
};

export default {
    getters,
    state,
    mutations,
    actions
};
